var isDecimalSelection=function(value,cursorPositon){var dotPosition=value.indexOf(".");return dotPosition!==-1&&dotPosition<cursorPositon};export default isDecimalSelection;
//# sourceMappingURL=isDecimalSelection.js.map